import { Provider } from '@angular/core';

import { LogisticsManageVacationsUseCasesImpl } from '@app/domain/use-cases/manage-vacations/logistics/logistics-manage-vacations.use-cases';
import { LOGISTICS_MANAGE_VACATIONS_USE_CASES } from '@app/domain/use-cases/manage-vacations/logistics/logistics-manage-vacations.use-cases.contract';

export const logisticsManageVacationsUseCasesProvider: Provider = {
  provide: LOGISTICS_MANAGE_VACATIONS_USE_CASES,
  useClass: LogisticsManageVacationsUseCasesImpl
};
